import { NgModule } from "@angular/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { HttpClient } from "@angular/common/http";
import { SharedModule } from "src/app/shared/shared.module";
import { CommonModule } from "@angular/common";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { AdministrarParametrosTotemComponent } from "./administrar-parametros-totem-component";
import { AdministrarParametrosTotemComponentRoutingModule } from "./administrar-parametros-totem-component.routing.module";

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "assets/i18n/formulario/", ".json");
}

@NgModule({
  declarations: [AdministrarParametrosTotemComponent],
  imports: [
    AdministrarParametrosTotemComponentRoutingModule,
    SharedModule,
    CommonModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
      isolate: true,
    }),
  ],
  entryComponents: [],
})
export class AdministrarParametrosTotemModule {}
